var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Metodo de Pagos","company":_vm.comdes,"addMethod":"itemsMetodoPago","closeBaseWindow":"addMetodoPago","titleAddMethod":"Agregar Metodo de Pagos","itemStoreName":"itemsMetodoPago","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Metodo de Pagos',
    edicion: 'Editar Metodo de Pagos',
    url: `/transjuma/MetodoPago/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }